import { render, staticRenderFns } from "./programAdd.vue?vue&type=template&id=be8a958e&scoped=true&"
import script from "./programAdd.vue?vue&type=script&lang=js&"
export * from "./programAdd.vue?vue&type=script&lang=js&"
import style0 from "./programAdd.vue?vue&type=style&index=0&id=be8a958e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8a958e",
  null
  
)

export default component.exports